import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/personal_externo';
import PersonalExterno from './PersonalExternoList';


const ms2p = (state) => {
  return {
    ...state.vm_personal_externo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PersonalExterno);
